export default class Tag {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    const seo = this.element.querySelector('.seo');
    const entrepreneur = this.element.querySelector('.entrepreneur');
    const tags = this.element.querySelectorAll('.tag');

    // Affiche SEO par défaut
    seo.classList.add('active');

    tags.forEach(tag => {
      tag.addEventListener('mouseenter', () => {
        if (tag.textContent.includes('SEO')) {
          this.switchBlocks(seo, entrepreneur, 'left');
        } else if (tag.textContent.includes('entrepreneur')) {
          this.switchBlocks(entrepreneur, seo, 'right');
        }
      });
    });
  }

  switchBlocks(showEl, hideEl, direction) {
    // Nettoyer classes
    hideEl.classList.remove('enter-left', 'enter-right', 'exit-left', 'exit-right');
    showEl.classList.remove('enter-left', 'enter-right', 'exit-left', 'exit-right', 'active');

    // Faire sortir l'ancien bloc
    if (direction === 'left') hideEl.classList.add('exit-right');
    else hideEl.classList.add('exit-left');

    // Après transition de sortie, faire apparaître le nouveau
    hideEl.addEventListener('transitionend', () => {
      hideEl.classList.remove('active', 'exit-left', 'exit-right');

      // Préparer le bloc à montrer
      if (direction === 'left') showEl.classList.add('enter-left');
      else showEl.classList.add('enter-right');

      // Force reflow pour que la transition se déclenche
      showEl.offsetWidth;

      // Activer le bloc
      showEl.classList.add('active');
      showEl.classList.remove('enter-left', 'enter-right');
    }, { once: true });
  }
}
